import { Tab, Tabs } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import AuthWall from "./AuthWall";
import FightResetter from "./FightResetter";
import GradesChecker from "./GradesChecker";
import JurorManager from "./JurorManager";
import JuryPlanManager from "./JuryPlanManager";
import LiveOverviewContent from "./LiveOverviewContent";
import ParticipantManager from "./ParticipantManager";
import Passwords from "./Passwords";

const styles = {
	container: css({
		display: "flex",
		flexWrap: "wrap",
		width: "100%",
	}),
	fullWidth: css({ width: "100%" }),
};

interface Props {
	dark: boolean;
}

export default class BackendTabs extends React.Component<Props, { tabId: React.ReactText }> {
	public state = { tabId: "lo" };
	public render() {
		return (
			<div>
				<AuthWall>
					<div {...styles.container}>
						<Tabs
							id="TabsExample"
							large={true}
							{...styles.fullWidth}
							onChange={(id) => this.setState({ tabId: id })}
							renderActiveTabPanelOnly={true}
						>
							<Tab
								id="lo"
								title="Overview"
								panel={<LiveOverviewContent dark={this.props.dark} />}
							/>
							<Tab id="gc" title="Grades" panel={<GradesChecker />} />
							<Tab id="pm" title="Participants" panel={<ParticipantManager />} />
							<Tab id="jm" title="Jurors" panel={<JurorManager />} />
							<Tab id="jpm" title="Jury Plan" panel={<JuryPlanManager />} />
							<Tab id="ps" title="Passwords" panel={<Passwords />} />
							<Tab id="fr" title="Reset Fights" panel={<FightResetter />} />
						</Tabs>
					</div>
				</AuthWall>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/BackendTabs.tsx